import { createSlice, current } from '@reduxjs/toolkit';
import {
	getWaterRightTypeList,
	getWaterRightType,
	addNewWaterRightType,
	updateWaterRightType,
	deleteWaterRightType,
	checkWaterRightTypeExists,
} from './thunk';

export const initialState = {
	itemWaterRightTypeList: [],
	itemWaterRightType: null,
	isWaterRightTypeLoading: false,
	isWaterRightTypeSuccess: false,
	dataWaterRightType: null,
	statementList: [],
	statementListSelect: [],
	isLoadingList: false,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	requireCloseModal: false,
	registerDisabled: false,
	requireReloadSelectionItemsGrid: false,
	exists: false,
};

const WaterRightTypeSlice = createSlice({
	name: 'WaterRightType',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		},
	},
	extraReducers: builder => {
		builder.addCase(getWaterRightTypeList.pending, state => {
			state.isLoadingList = true;
			state.isWaterRightTypeSuccess = false;
		});

		builder.addCase(getWaterRightTypeList.fulfilled, (state, action) => {
			let statementList = action.payload;
			let statementListSelect = [];

			action.payload.map(item =>
				statementListSelect.push({
					item: item,
					value: item._id,
					label: item.name,
				})
			);

			state.itemWaterRightTypeList = statementList;
			state.statementList = statementList;
			state.statementListSelect = statementListSelect;
			state.isLoadingList = false;
			state.isWaterRightTypeSuccess = true;
		});

		builder.addCase(getWaterRightTypeList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isWaterRightTypeSuccess = false;
		});

		builder.addCase(getWaterRightType.pending, state => {
			state.isWaterRightTypeLoading = true;
			state.isWaterRightTypeSuccess = false;
		});

		builder.addCase(getWaterRightType.fulfilled, (state, action) => {
			state.itemWaterRightType = action.payload;
			state.isWaterRightTypeLoading = false;
			state.isWaterRightTypeSuccess = true;
		});

		builder.addCase(getWaterRightType.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isWaterRightTypeLoading = false;
			state.isWaterRightTypeSuccess = false;
		});

		builder.addCase(addNewWaterRightType.pending, state => {
			state.isLoadingList = true;
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});

		builder.addCase(addNewWaterRightType.fulfilled, (state, action) => {
			state.itemWaterRightTypeList.push(action.payload);
			state.statementList.push(action.payload);
			state.statementListSelect.push({
				item: action.payload,
				value: action.payload._id,
				label: action.payload.name,
			});
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = true;
			state.requireCloseModal = true;
		});

		builder.addCase(addNewWaterRightType.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAddError = true;
		});

		builder.addCase(updateWaterRightType.pending, state => {
			state.isLoadingList = true;
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
		});

		builder.addCase(updateWaterRightType.fulfilled, (state, action) => {
			state.itemWaterRightTypeList = state.itemWaterRightTypeList.map(
				waterRightTypeList =>
					waterRightTypeList._id.toString() === action.payload._id.toString()
						? { ...waterRightTypeList, ...action.payload }
						: waterRightTypeList
			);
			state.statementList = state.statementList.map(waterRightTypeList =>
				waterRightTypeList._id.toString() === action.payload._id.toString()
					? { ...waterRightTypeList, ...action.payload }
					: waterRightTypeList
			);
			state.statementListSelect = state.statementListSelect.map(item =>
				item.value.toString() === action.payload._id.toString()
					? {
							item: action.payload,
							value: action.payload._id,
							label: action.payload.name,
					  }
					: item
			);
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = true;
			state.requireCloseModal = true;
		});

		builder.addCase(updateWaterRightType.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdateError = true;
		});

		builder.addCase(deleteWaterRightType.pending, state => {
			state.isLoadingList = true;
			state.isDeleting = true;
			state.isDeleted = false;
			state.isDeleteError = false;
		});

		builder.addCase(deleteWaterRightType.fulfilled, (state, action) => {
			state.itemWaterRightTypeList = current(state.itemWaterRightTypeList).filter(
				item => item._id !== action.payload._id
			);
			state.statementList = current(state.statementList).filter(
				item => item._id !== action.payload._id
			);
			state.statementListSelect = current(state.statementListSelect).filter(
				item => item.value !== action.payload._id
			);
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = true;
			state.requireCloseModal = true;
		});

		builder.addCase(deleteWaterRightType.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleteError = true;
		});

		builder.addCase(checkWaterRightTypeExists.pending, state => {
			state.exists = false;
		});

		builder.addCase(checkWaterRightTypeExists.fulfilled, (state, action) => {
			state.exists = action.payload.exists;
		});

		builder.addCase(checkWaterRightTypeExists.rejected, (state, action) => {
			state.exists = false;
		});
	},
});

export const { setRequireCloseModal } = WaterRightTypeSlice.actions;

export default WaterRightTypeSlice.reducer;
